// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-body[data-v-4da48456] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: left;\n      -ms-flex-pack: left;\n          justify-content: left;\n}\n.dialog-body .el-form[data-v-4da48456] {\n  width: 100%;\n}\n.dialog-footer[data-v-4da48456] {\n  margin-top: 0;\n}", ""]);
// Exports
module.exports = exports;
